import { System, SystemSummary } from '@x/types';
import { ApiMutationConfig, ApiQueryConfig } from 'api/types';
import { URLS } from 'config';
import { urlPart } from 'data';
import { SystemConfigResult } from 'features/integration/types';
import { createApiEndpoint } from '../utils';

const systemsUrl = `${URLS.app}/api/Systems`;

type GetSystemsConfig = ApiQueryConfig<SystemSummary[]>;

export const getSystems = createApiEndpoint<GetSystemsConfig>({
  url: `${systemsUrl}/Get`,
  method: 'GET',
});

type SystemsPathParam = {
  $systemId: urlPart;
};

type GetIntegrationSystemSchemaConfig = ApiQueryConfig<
  string | null,
  SystemsPathParam
>;

export const getIntegrationSystemSchema =
  createApiEndpoint<GetIntegrationSystemSchemaConfig>({
    url: `${systemsUrl}/$systemId/Schema`,
    method: 'GET',
  });

type GetIntegrationConfigValuesQueryParams = {
  orgId: urlPart;
  show?: boolean;
};

type GetIntegrationConfigValuesConfig = ApiQueryConfig<
  SystemConfigResult,
  SystemsPathParam,
  GetIntegrationConfigValuesQueryParams
>;

export const getIntegrationConfigValues =
  createApiEndpoint<GetIntegrationConfigValuesConfig>({
    url: `${systemsUrl}/$systemId/configuration/v2`,
    method: 'GET',
  });

type CreateInitialSystemConfigQueryParams = {
  orgId: number;
};

type CreateInitialSystemConfigConfig = ApiMutationConfig<
  unknown,
  SystemsPathParam,
  SystemConfigResult,
  CreateInitialSystemConfigQueryParams
>;

export const createInitialSystemConfig =
  createApiEndpoint<CreateInitialSystemConfigConfig>({
    url: `${systemsUrl}/$systemId/configuration`,
    method: 'POST',
  });

type SaveIntegrationConfigBody = {
  Configuration: Record<string, unknown>;
  Id: number;
};

type SaveIntegrationConfigConfig = ApiMutationConfig<
  SaveIntegrationConfigBody,
  unknown,
  unknown,
  void
>;

export const saveIntegrationConfig =
  createApiEndpoint<SaveIntegrationConfigConfig>({
    url: `${systemsUrl}/SaveConfiguration/v2`,
    method: 'POST',
  });

type PostSystemsConfig = ApiMutationConfig<Partial<System>, unknown, System>;

type PostSystemSettingsConfig = ApiMutationConfig<
  {
    Id: urlPart;
    Configuration: Record<string, unknown>;
  },
  unknown,
  System
>;

type DeleteSystemConfig = ApiMutationConfig<unknown, { $systemId?: urlPart }>;

export const upsertSystems = createApiEndpoint<PostSystemsConfig>({
  url: `${systemsUrl}/Post`,
  method: 'POST',
});

export const postSystemSettings = createApiEndpoint<PostSystemSettingsConfig>({
  url: `${systemsUrl}/SaveSettings`,
  method: 'POST',
});

export const deleteSystem = createApiEndpoint<DeleteSystemConfig>({
  url: `${systemsUrl}/$systemId/Remove`,
  method: 'POST',
  invalidateNthAncestor: 2,
});
